import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { area } from '@src/utils/area';

const Confirm = ({ confirmData, confirmDataHandle, updateId, languages }) => {
    const tipText = updateId ? area[languages].confirm.title2 : area[languages].confirm.title1;

    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>{tipText}</div>
                <div className={styles.confirmOperate}>
                    <div
                        className={styles.confirmYes}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                        }}>
                        {area[languages].confirm.confirmText}
                    </div>
                    <div
                        className={styles.confirmCancel}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                        }}>
                        {area[languages].confirm.checkIt}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

Confirm.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
    updateId: PropTypes.string,
    languages: PropTypes.string,
};

export default errorBoundary(Confirm);
